<template>
  <div class='flex justify-between items-start mt-1'>
    <div>
      <slot />
    </div>
    <p class='text-xs text-right text-janaturq-400'>{{ props.preTitle }} | {{ formatDate(props.date) }}<br />{{ props.title }}</p>
  </div>
</template>

<script setup>

import { formatDate } from '@/kernel/report';

const props = defineProps({
  preTitle: String,
  date: Date,
  title: String
});

</script>
